document.addEventListener('DOMContentLoaded', function() {
    // Initialize Float Text Animation
    function initObserver() {
        const elements = document.querySelectorAll('.float-text');
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('active');
                        observer.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.1 }
        );
        elements.forEach((el) => observer.observe(el));
    }

    // Initialize Video Modal
    function initVideoModal() {
        const btn = document.querySelector('.watch-video-btn');
        const modal = document.querySelector('.video-modal-overlay');
        const closeBtn = document.querySelector('.video-close-btn');
        const video = modal ? modal.querySelector('video') : null;

        if (btn && modal && video) {
            btn.addEventListener('click', () => {
                modal.classList.add('active');
                video.play();
            });

            closeBtn.addEventListener('click', () => {
                modal.classList.remove('active');
                video.pause();
            });

            modal.addEventListener('click', (e) => {
                if (e.target === modal) {
                    modal.classList.remove('active');
                    video.pause();
                }
            });
        }
    }

    // Run initializations
    initObserver();
    initVideoModal();
});
